import React from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Space,
} from 'antd';
import moment from 'moment';
import DebounceSelect from '../../Forms/DebounceSelect';
import * as Config from '../../../appConfig';
import {
  activePeriod,
  disabledDate,
  isSunday,
  calculateNumberOfBusinessDays,
} from '../../../utils/date';

const { RangePicker } = DatePicker;

const AddLeaveForm = ({
  leave,
  lookupData,
  onLookup,
  types,
  onLeaveSubmit,
  onCancelClick,
  fetching,
  ability,
}) => {
  const [form] = Form.useForm();

  const [selectedEmployee, setSelectedEmployee] = React.useState(
    leave
      ? {
          value: `${leave.employee.id}`,
          label: `${leave.employee.first_name} ${leave.employee.last_name} (${leave.employee.emp_id})`,
        }
      : {}
  );

  console.log('selectedEmployee ////', selectedEmployee);

  const [freezePrevMonth, currentMonth, prevMonth] = activePeriod();

  const calculateDuration = () => {
    const values = form.getFieldsValue();
    if (typeof values.leave_period !== 'undefined' && values.leave_period) {
      const [start, end] = values.leave_period;
      const reduceHalfDay =
        typeof values.half_day !== 'undefined' &&
        (values.half_day === '1' || values.half_day === '2')
          ? 0.5
          : 0;
      form.setFieldsValue({
        days_calculated: calculateNumberOfBusinessDays(start, end) - reduceHalfDay,
      });
    } else {
      form.setFieldsValue({
        days_calculated: 0,
      });
    }
  };

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        size="large"
        className="ant-form-custom"
        onValuesChange={() => {
          calculateDuration();
        }}
        initialValues={{
          id: leave && leave.id,
          leave_type_id: leave && leave.leave_type && leave.leave_type.id,
          half_day: leave && leave.half_day ? `${leave.half_day}` : '0',
          leave_period: leave &&
            leave.date_from &&
            leave.date_to && [moment(leave.date_from), moment(leave.date_to)],
          days_calculated: leave && leave.days_calculated,
          note: leave && leave.note,
          employee: selectedEmployee,
        }}
        onFinish={(values) =>
          onLeaveSubmit(values, (updated) => {
            if (updated.status === 2) {
              // setShowRelieveModal(false);
            }
          })
        }
        style={{ marginTop: '0' }}
      >
        <Row>
          <Col xs={24}>
            <Form.Item
              label="Employee"
              name="employee"
              rules={[
                {
                  required: true,
                  message: 'Please input Employee!',
                },
              ]}
            >
              <DebounceSelect
                showSearch={leave && leave.id ? false : true}
                disabled={leave && leave.id ? true : false}
                defaultValue={selectedEmployee}
                value={selectedEmployee}
                placeholder="Search employee"
                data={
                  lookupData && lookupData.length
                    ? lookupData
                    : leave
                    ? [
                        {
                          label: `${leave.employee.first_name} ${leave.employee.last_name} (${leave.employee.emp_id})`,
                          value: leave.employee.id,
                        },
                      ]
                    : []
                }
                onLookup={onLookup}
                onChange={(newValue) => {
                  setSelectedEmployee(newValue);
                }}
                style={{
                  width: '100%',
                }}
                fetching={fetching}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12}>
            <Form.Item
              label="Leave Type"
              name="leave_type_id"
              rules={[
                {
                  required: true,
                  message: 'Please select Leave Type!',
                },
              ]}
            >
              <Select placeholder="Please select">
                {types &&
                  types.map((type) => (
                    <Select.Option key={type.id} value={type.id}>
                      {type.name} ({type.code})
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <Form.Item
              label="Leave Period"
              name="leave_period"
              rules={[
                {
                  required: true,
                  message: 'Please select leave period!',
                },
              ]}
            >
              <RangePicker
                disabledDate={(current) =>
                  disabledDate(current, freezePrevMonth, currentMonth, prevMonth) || isSunday(current)
                }
                format={Config.DATE_FORMAT_INPUT}
                // onChange={(dates) => {
                //   console.log(form.getFieldsValue());
                //   if (dates) {
                //     const [start, end] = dates;
                //     const values = form.getFieldsValue();
                //     const reduceHalfDay =
                //       typeof values.half_day !== 'undefined' &&
                //       (values.half_day === '1' || values.half_day === '2')
                //         ? 0.5
                //         : 0;
                //     form.setFieldsValue({
                //       days_calculated:
                //         end.diff(start, 'days') + 1 - reduceHalfDay,
                //     });
                //   } else {
                //     form.setFieldsValue({
                //       days_calculated: 0,
                //     });
                //   }
                // }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12}>
            <Form.Item
              label="Half Day"
              name="half_day"
              rules={[
                {
                  required: true,
                  message: 'Please select Partial (Half) Day!',
                },
              ]}
            >
              <Select placeholder="Please select">
                <Select.Option key="0" value="0">
                  No Half Day
                </Select.Option>
                <Select.Option key="1" value="1">
                  Start Day
                </Select.Option>
                <Select.Option key="2" value="2">
                  End Day
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12}>
            <Form.Item label="Days Calculated" name="days_calculated">
              <Input
                placeholder="Days Calculated"
                htmlType="number"
                readOnly
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <Form.Item label="Note" name="note">
              <Input placeholder="Note" maxLength="255" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} align="right">
            <Space>
              <Button type="secondary" size="middle" onClick={onCancelClick}>
                Cancel
              </Button>
              <Button type="primary" size="middle" htmlType="submit">
                Save
              </Button>
            </Space>
          </Col>
        </Row>
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
      </Form>
    </>
  );
};

export default AddLeaveForm;
